export default function({
    settings = {},
    name,
    onChange
}) {

    return [
        {
            type: "InputNumber",
            data: {
                onChange,
                attrs: {
                    value: settings[name],
                    placeholder: "Введите кол-во мегабайт"
                }
            }
        }
    ]
}